/**
 * Fetch categories from deployment base URL (categories.json).
 * Use from client or server; pass deployment base URL from config.
 */

import { fetchWrapper } from "~/lib/fetch";

export interface Category {
  id: string;
  name: string;
  slug: string;
}

const DEFAULT_DEPLOYMENT_BASE =
  "https://objectstorage.apps.henga.co/diaspora-dollar/deployment/";

export async function getCategories(
  deploymentBaseUrl?: string,
): Promise<Category[]> {
  const base = (deploymentBaseUrl ?? DEFAULT_DEPLOYMENT_BASE).replace(
    /\/?$/,
    "/",
  );
  const url = `${base}categories.json`;
  const res = await fetchWrapper(url);
  if (!res.ok) throw new Error(`Failed to load categories: ${res.status}`);
  const data = (await res.json()) as { name: string; value: string }[];
  if (!Array.isArray(data)) return [];
  return data.map((item) => ({
    id: item.value,
    name: item.name,
    slug: item.value,
  }));
}
